module.exports = __webpack_public_path__ + "img/input-error.02cf28ed.svg";